// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newCommentFormContainer {
    width: 90%;
    padding: 2rem;
    margin-left: 5%;
    border-radius: 15px;
}

.newCommentFormContainer__form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    gap: 2rem;
}

.newCommentButton {
    left: 50%;
    transform: translateX(-50%);
}

.newCommentFormContainer__form__buttonsContainer {
    display: flex;
    justify-content: center;
    gap: 2rem;
}

.newCommentFormContainer__form__buttonsContainer__icon--progress {
    color: white;
    width: 0.875rem !important;
    height: 0.875rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/comments/newComment/NewComment.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,SAAS;AACb;;AAEA;IACI,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":[".newCommentFormContainer {\n    width: 90%;\n    padding: 2rem;\n    margin-left: 5%;\n    border-radius: 15px;\n}\n\n.newCommentFormContainer__form {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    gap: 2rem;\n}\n\n.newCommentButton {\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.newCommentFormContainer__form__buttonsContainer {\n    display: flex;\n    justify-content: center;\n    gap: 2rem;\n}\n\n.newCommentFormContainer__form__buttonsContainer__icon--progress {\n    color: white;\n    width: 0.875rem !important;\n    height: 0.875rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
